module.exports = __webpack_public_path__ + "static/media/Wearpeachi_2_Perk High Waist Shortie in Navy.5fd80d64.jpeg";